"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.verify = void 0;
var parse_headers_1 = __importDefault(require("parse-headers"));
var decrypter_1 = require("./decrypter");
/**
 * Parses the lines of a message into an array of message sections.
 * @param lines - The lines of the message.
 * @returns An array of message sections.
 */
function splitSections(lines) {
    var sections = [[]];
    for (var _i = 0, lines_1 = lines; _i < lines_1.length; _i++) {
        var line = lines_1[_i];
        if (line === '') {
            sections.push([]);
        }
        else {
            sections[sections.length - 1].push(line);
        }
    }
    return sections;
}
/**
 * Extracts the domain from an array of message sections.
 * @param sections - An array of message sections.
 * @returns The domain, or `null` if it cannot be extracted.
 */
function extractTokenDomain(sections) {
    var lastLine = sections[0][sections[0].length - 1];
    if (lastLine.endsWith(' wants you to sign in with your Ethereum account.')) {
        return lastLine
            .replace(' wants you to sign in with your Ethereum account.', '')
            .trim();
    }
    return null;
}
/**
 * Extracts the statement from an array of message sections.
 * @param sections - An array of message sections.
 * @returns The statement, or `null` if it cannot be extracted.
 */
function extractTokenStatement(sections) {
    if (sections.length === 2 && !extractTokenDomain(sections)) {
        return sections[0][0];
    }
    if (sections.length === 3) {
        return sections[1][0];
    }
    return null;
}
/**
 * Parses the decrypted body of a token.
 * @param lines - The lines of the decrypted body.
 * @returns The parsed decrypted body.
 * @throws An error if the decrypted body is damaged.
 */
var parseBody = function (lines) {
    var bodySections = splitSections(lines);
    var mainBodySection = bodySections[bodySections.length - 1].join('\n');
    var parsedHeaders = (0, parse_headers_1["default"])(mainBodySection);
    for (var key in parsedHeaders) {
        var hyphenatedKey = key.replace(/ /g, '-');
        parsedHeaders[hyphenatedKey] =
            parsedHeaders[key];
        if (hyphenatedKey !== key) {
            delete parsedHeaders[key];
        }
    }
    var tokenDomain = extractTokenDomain(bodySections);
    var tokenStatement = extractTokenStatement(bodySections);
    if (typeof parsedHeaders['issued-at'] === 'undefined' ||
        typeof parsedHeaders['expiration-time'] === 'undefined' ||
        typeof parsedHeaders['web3-token-version'] === 'undefined') {
        throw new Error('Decrypted body is damaged');
    }
    return __assign(__assign({}, parsedHeaders), { domain: tokenDomain || undefined, statement: tokenStatement || undefined });
};
/**
 * Verifies a token.
 * @param token - The token to verify.
 * @param opts - The options for verifying the token.
 * @returns The verified token.
 * @throws An error if the token is expired, not yet valid, has an inappropriate domain, or is version 1.
 */
var verify = function (token, opts) {
    if (opts === void 0) { opts = {}; }
    var _a = (0, decrypter_1.decrypt)(token), version = _a.version, address = _a.address, body = _a.body;
    if (version === 1) {
        throw new Error('Tokens version 1 are not supported by the current version of module');
    }
    var lines = body.split('\n');
    var parsed_body = parseBody(lines);
    if (new Date(parsed_body['expiration-time']) < new Date()) {
        throw new Error('Token expired');
    }
    if (parsed_body['not-before'] &&
        new Date(parsed_body['not-before']) > new Date()) {
        throw new Error("It's not yet time to use the token");
    }
    if (opts.domain && opts.domain !== parsed_body.domain) {
        throw new Error('Inappropriate token domain');
    }
    return { address: address, body: parsed_body };
};
exports.verify = verify;
